export default "#### **Delivery**\n\nAnywhere within Greater Sydney\n";